import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';
import CardPrecios from '../CardPrecios';

const ModalReemplazo = ({ dadComponent, dataToCard }) => {
    // debugger;
    const VISIBLE = dadComponent.state.addToCart;
    const CARRITO_MODAL = dadComponent['showCarrito'];
    const TOGGLE_MODAL = dadComponent['showModalCart'];
    const TOGGLE_MODAL_KIT = dadComponent['toggleModalKit'];
    return (
        <div>
            <Modal returnFocusAfterClose={false} isOpen={VISIBLE} toggle={TOGGLE_MODAL} className='modal_add_cart' centered backdrop="static">
                <ModalHeader>
                    <button className="btn-icon modal-close" onClick={TOGGLE_MODAL}><SvgAssets icon="icon-close" fill={c.celeste} /></button>
                    <h6 style={{ color: '#fff' }}>
                        <SvgAssets icon="icon-check" fill={'#fff'} className="mr-3" />
                        El producto se agregó al carrito de compras
                    </h6>
                </ModalHeader>
                <ModalBody>
                    <div className="card_product_horizontal card_oferta">
                        <div className="cphLeftImage">
                            {/* <img src={require('../../../assets/img/product.png')} /> */}
                            <a style={{ cursor: 'pointer' }} onClick={() => dadComponent.toggleModalZoom(dataToCard.pathI)}>
                                <img src={dataToCard.pathI} />
                            </a>
                            {dataToCard.flagKit ?
                                (
                                    <button className='btn-icon' onClick={() => dadComponent.toggleModalKit(dataToCard.codigo, dataToCard.descripcion)}>
                                        <SvgAssets icon="icon-kit" fill={'#ED7F9A'} />
                                    </button>) :
                                ('')}
                        </div>
                        <div className="cphTextCenter">
                            <div>
                                <h6 className="paragraph-2 bold mb-1" style={{ color: c.grisOscuro }}>{dataToCard.descripcion}</h6>
                                <span className="paragraph-3" style={{ color: c.grisMedio }}>SKU: {dataToCard.codigo}</span>
                            </div>
                            <div className="mt-3">
                                <CardPrecios data={dataToCard.precios || []} escalas={dataToCard.escalas} cantidad={dataToCard.cantidad} className="cardPrice" />
                                {/* <span className="paragraph-3 bold" style={{color:c.grisMedio}}>{dataToCard.precioPVD}</span>
                        <span className="paragraph-3" style={{color:c.grisMedio}}>{dataToCard.precioPVP}</span> */}
                            </div>
                            <div className="mt-3">
                                <span className="paragraph-3 mb-1 bold">CANTIDAD: {dataToCard.cantidad} {dataToCard.unidadMedida}</span>
                                {/* <span className="paragraph-3" style={{ color: c.naranja }}>TOTAL: {(dataToCard.precioFinal || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span> */}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a className="bold" onClick={TOGGLE_MODAL}>Seguir Comprando</a>
                        {/* <Link to="/carrito"
                            className="btn-small bg_transparent"
                        > */}
                        <button
                            className="btn-small bg_transparent"
                            type="button"
                            onClick={CARRITO_MODAL}
                        >
                            <SvgAssets icon="icon-cart" fill={c.rojoClaro} />Ir a mi carrito
                        </button>
                        {/* </Link> */}
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ModalReemplazo;